class MediaGridVideoModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.content = this.querySelector('.media-grid-video-modal__content');
    this.closeButton = this.querySelector('.media-grid-video-modal__close');
    this.scope = this.closest('.shopify-section') || document;

    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onDialogClick = this.onDialogClick.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);

    this.scope.addEventListener('click', this.onClick);
    this.scope.addEventListener('keydown', this.onKeydown);
    this.closeButton.addEventListener('click', () => this.dialog.close());
    this.dialog.addEventListener('click', this.onDialogClick);
    this.dialog.addEventListener('close', this.onDialogClose);
  }

  disconnectedCallback() {
    this.scope.removeEventListener('click', this.onClick);
    this.scope.removeEventListener('keydown', this.onKeydown);
  }

  onClick(event) {
    const trigger = event.target.closest('[data-media-grid-video-trigger]');
    if (!trigger || !this.scope.contains(trigger)) return;
    event.preventDefault();
    this.open(trigger);
  }

  onKeydown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest('[data-media-grid-video-trigger]');
    if (!trigger || !this.scope.contains(trigger)) return;
    event.preventDefault();
    this.open(trigger);
  }

  onDialogClick(event) {
    const rect = this.dialog.getBoundingClientRect();
    const inDialog = event.clientX >= rect.left && event.clientX <= rect.right
      && event.clientY >= rect.top && event.clientY <= rect.bottom;
    if (!inDialog) this.dialog.close();
  }

  onDialogClose() {
    this.content.innerHTML = '';
    if (this.lastTrigger) {
      this.lastTrigger.focus();
      this.lastTrigger = null;
    }
  }

  open(trigger) {
    const mp4 = trigger.dataset.modalVideoMp4;
    const host = trigger.dataset.modalVideoHost;
    const id = trigger.dataset.modalVideoId;

    let markup = '';
    if (mp4) {
      markup = `<video controls autoplay playsinline preload="metadata"><source src="${this.escape(mp4)}"></video>`;
    } else if (host === 'youtube' && id) {
      const safeId = encodeURIComponent(id);
      markup = `<iframe src="https://www.youtube.com/embed/${safeId}?autoplay=1&playsinline=1&rel=0&modestbranding=1" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>`;
    } else if (host === 'vimeo' && id) {
      const safeId = encodeURIComponent(id);
      markup = `<iframe src="https://player.vimeo.com/video/${safeId}?autoplay=1" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>`;
    }

    if (!markup) return;
    this.lastTrigger = trigger;
    this.content.innerHTML = markup;
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  escape(value) {
    return String(value).replace(/"/g, '&quot;');
  }
}

if (!customElements.get('media-grid-video-modal')) {
  customElements.define('media-grid-video-modal', MediaGridVideoModal);
}
